var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.modulesFilter(_vm.currentModule),{tag:"component",attrs:{"current-module":_vm.moduleConfigure,"current-module-item-data-id":_vm.moduleItemDataId,"current-module-item-data-headline":_vm.moduleItemDataHeadline}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }